import React from "react";
import Breadcrumb from "antd/es/breadcrumb";
import { Button, Typography } from "antd";
import Card from "antd/es/card/Card";
import { ItemType } from "antd/es/breadcrumb/Breadcrumb";

import clsx from "clsx";
import styles from "./index.module.scss";
import { ArrowLeftOutlined } from "@ant-design/icons";

interface SinglePageContainer extends React.PropsWithChildren {
  breadcrumbItems?: ItemType[];
  title: React.ReactNode;
  extra?: React.ReactNode;
  cardLoading?: boolean;
  className?: string;
  style?: React.CSSProperties;
  stickyHeader?: boolean;
  onBack?: () => void;
  transparent?: boolean;
  noPadding?: boolean;
}

export default function SinglePageContainer({
  breadcrumbItems = [],
  title,
  cardLoading = false,
  extra = undefined,
  children,
  className = "",
  style,
  onBack,
  stickyHeader = false,
  transparent = false,
  noPadding = false,
}: SinglePageContainer) {
  return (
    <div className="transparent">
      {breadcrumbItems.length > 0 ? (
        <Breadcrumb
          className="page-header-breadcrumb"
          items={breadcrumbItems}
        />
      ) : null}
      {onBack ? (
        <Button onClick={onBack} icon={<ArrowLeftOutlined />}>
          Back
        </Button>
      ) : null}

      <div
        className={clsx(styles.heading, {
          [styles.stickyHeader]: stickyHeader,
        })}
      >
        <Typography.Title level={4} className={styles.pageTitle}>
          {title}
        </Typography.Title>
      </div>

      <Card
        loading={cardLoading}
        className={clsx(
          className,
          {
            [styles.transparentCard]: transparent,
            [styles.noPaddingCard]: noPadding,
          }
        )}
        style={style}
        bodyStyle={noPadding ? { padding: 0 } : undefined}
      >
        {children}
        {extra && <div className={styles.extra}>{extra}</div>}
      </Card>
    </div>
  );
}